import { useRef, useState } from 'react';

/** 동일 이벤트 주기의 중복 요청도 차단하고, 성공한 응답만 소비자에게 돌려준다. */
export const useAsyncAction = <Input, Output>(
  operation: (input: Input) => Promise<Output>,
  onSuccess: () => void,
) => {
  const pending = useRef(false);
  const [isPending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isConflict, setConflict] = useState(false);
  const execute = async (input: Input): Promise<Output | undefined> => {
    if (pending.current) return;
    pending.current = true;
    setPending(true);
    setError(null);
    setConflict(false);
    try {
      const result = await operation(input);
      onSuccess();
      return result;
    } catch (cause) {
      setError(
        typeof cause === 'object' && cause !== null && 'message' in cause
          ? String(cause.message)
          : '요청을 처리하지 못했습니다. 다시 시도해주세요.',
      );
      setConflict(
        typeof cause === 'object' &&
          cause !== null &&
          'data' in cause &&
          typeof cause.data === 'object' &&
          cause.data !== null &&
          'code' in cause.data &&
          cause.data.code === 'CONFLICT',
      );
      return;
    } finally {
      pending.current = false;
      setPending(false);
    }
  };
  return {
    execute,
    isPending,
    error,
    isConflict,
    reset: () => {
      setError(null);
      setConflict(false);
    },
  };
};
